const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://m-dev.stagvn.com'
const FLEX_APP = process.env.REACT_APP_FLEX_APP
const STAG_APP_NAME = {
  employee: 'Stag Invest',
  business: 'Stag FutureFlex'
}

const getUrl = url => `${API_BASE_URL}${url}`
const API_VERSION = 'v7'

export { API_BASE_URL, API_VERSION, FLEX_APP, getUrl, STAG_APP_NAME }
